import { Injectable } from '@angular/core';
import { HomeNavigationConfigService } from 'gung-standard';

@Injectable({
  providedIn: 'root'
})
export class CarLinerHomeNavigationConfigService extends HomeNavigationConfigService {
  adminLink = ['/products'];
  salesLink = ['/products'];
  multiCustomersUserLink = ['/products'];
  singleCustomerUserLink = ['/products'];
  anonymousLink = ['/products'];
}
